"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "appshellReducer", {
  enumerable: true,
  get: function get() {
    return _reducer.default;
  }
});
Object.defineProperty(exports, "appshellSaga", {
  enumerable: true,
  get: function get() {
    return _sagas.default;
  }
});
Object.defineProperty(exports, "appshellState", {
  enumerable: true,
  get: function get() {
    return _state.default;
  }
});
exports.appshellActions = void 0;

var appshellActions = _interopRequireWildcard(require("./actions"));

exports.appshellActions = appshellActions;

var _reducer = _interopRequireDefault(require("./reducer"));

var _sagas = _interopRequireDefault(require("./sagas"));

var _state = _interopRequireDefault(require("./state"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}